(function ($) {
  pcgSkuImageTitleV1 = {
    formatter: $('.pcg-sku-image-title-v1')
  };

  Drupal.behaviors.pcgSkuImageTitleV1 = {
    get: function (key) {
      return pcgSkuImageTitleV1[key];
    },

    set: function (key, val) {
      pcgSkuImageTitleV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        /*
      // Add "pcg-product-sku" to the "ul.items" element to then be able to hide the shades div only for the "pcg-product-sku" in quickview
      // We're using this selector inside "_pcg_product_large_v1.scss": .items.pcg-product-sku .module-spp-detail .shades { display: none; }
      var items = thisFormatter.closest('.items');
      items.addClass('pcg-product-sku');
*/

        // Implementing multi-colored swatches in multi-sku shades. DoneDone #156 - Taken from: product_content_hotlist_v1.js
        // This might be moved to more global location
        // Check if the SKU have more than 1 shade
        thisFormatter.each(function () {
          var pcgProductSku = $(this),
            shadeBox = pcgProductSku.find('.product-shade .shade-box'),
            skuShade = shadeBox.attr('data-skushade');

          if (skuShade !== undefined) {
            var shades = skuShade.split(',').length,
              shade = skuShade.split(',');

            if (shades === 1) {
              shadeBox.addClass('single-shade');
            } else {
            // If there are 2 or more shades add multi-shade class and hide shade-box
              shadeBox.addClass('multi-shade');
              $('.multi-shade').closest('.product-shade').addClass('multi-shade-parent');
              $('.multi-shade').hide();
              // Iterate through available shades and rebuild shade-box divs
              for (var i = 0; i < shades; i++) {
                pcgProductSku.find('.product-shade.multi-shade-parent').prepend('<div style="background-color: ' + shade[i] + '" class="shade-box single-shaded item-' + i + '"></div>');
                pcgProductSku.find('.product-shade.multi-shade-parent').find('.shade-box.single-shaded.item-0').addClass('first').css({ 'margin-right': '6px' });
                var width;

                // We don't know how many shades could be in a SKU
                // Let's deal with up to 5
                switch (shades) {
                  case 2:
                    width = '9px';
                    break;
                  case 3:
                    width = '6px';
                    break;
                  case 4:
                    width = '4px';
                    break;
                  case 5:
                    width = '3px';
                    break;
                  default:
                    width = '2px';
                }
                pcgProductSku.find('.product-shade.multi-shade-parent').find('.shade-box.single-shaded').css({
                  'width': width,
                  'margin-right': '1px'
                });
              }
            }
          }
        });

        // quickview slide down
        // Added to enable quickview slide down feature in the "PCG Product SKU - v1" template - DoneDone #141
        var quickViewBtn = thisFormatter.find('.btn-quickview');

        quickViewBtn.once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();
          var $thisElem = $(this);

          $('#quickshop .close').trigger('click');
          var prodId = $(this).closest('.product').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p.PRODUCT_ID === prodId;
            })[0];

            if (product && !product.skus) {
              product.skus = page_data['product-input-type'].skus.filter(function (p) {
                return p.PRODUCT_ID === prodId;
              });
            }
            var $qs = site.quickshop.render({
              productData: product
            });

            $('.caret').filter(':not(.hidden)').addClass('hidden');

            var clickedProduct = $(this).closest('.product');
            var bottom_padding = 50;
            var speed = 500;
            var topPositionNavOffset = $('#top').height() + 40;

            // append after row
            $qs.insertAfter($(this).parents('.row')).addClass('pcg-sku-carousel').delay(100).slideDown(speed, function () {
              var pos = $qs.position();
              var window_height = $(window).height();
              var offset = $qs.offset();
              var posY = offset.top - $(window).scrollTop();
              var clickedProductOffset = clickedProduct.offset();
              var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
              var qs_bottom_position = posY + $('#quickshop').height() + bottom_padding;

              // only scroll page if the quickshop fall within the viewable area
              if (qs_bottom_position > window_height) {
              /**
               * bottom of quickshop isn't visible, so let's formulate both options
              **/
                // option 1: place selected product near top of viewing area
                var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
                // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
                var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
                // select our best option
                var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

                // now scroll the window...
                $('body, html').scrollTo(scrollPosition, {
                  duration: speed,
                  axis: 'y'
                });
              }
            });
            // override close to remove dom node
            $qs.find('.close').off('click').on('click', function() {
              $qs.slideUp('500', function () {
                $qs.remove();
                $thisElem.closest('.grid-content, ul.slides').find('div[data-productid="' + product.PRODUCT_ID + '"] .caret').addClass('hidden');
              });
            });
            // show caret
            $thisElem.closest('.grid-content, ul.slides').find('div[data-productid="' + product.PRODUCT_ID + '"] .caret').removeClass('hidden');
          }
        });
      });
    }
  };
})(jQuery);
